
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype1 as ObiMosfetPtype1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-1.js';
 
 
 

 
 export const ObiMosfetPtype1 = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-1',
   elementClass: ObiMosfetPtype1Element,
   events: {
     
   }
  });
 
 